import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/hakkimizda', label: 'Hakkımızda' },
    { path: '/urunler', label: 'Ürünler' },
    { path: '/projeler', label: 'Projeler' },
    { path: '/ozel-tasarim', label: 'Özel Tasarım' },
    { path: '/iletisim', label: 'İletişim' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="flex items-baseline">
            <span className={`text-2xl font-semibold tracking-tight transition-colors ${
              isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'
            }`}>
              Atölye
            </span>
            <span className="text-2xl font-semibold tracking-tight text-coral ml-0.5">
              mini
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-coral'
                  : isScrolled || !isHomePage
                  ? 'text-navy hover:text-coral'
                  : 'text-white hover:text-coral'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <Link
          to="/iletisim"
          className="hidden md:block px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap bg-coral text-white hover:bg-coral/90 cursor-pointer"
        >
          Teklif Al
        </Link>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center ${
            isScrolled || !isHomePage ? 'text-navy' : 'text-white'
          }`}
        >
          <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path ? 'text-coral' : 'text-navy hover:text-coral'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/iletisim"
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-6 py-2.5 rounded-full text-sm font-medium text-center bg-coral text-white hover:bg-coral/90 cursor-pointer whitespace-nowrap"
            >
              Teklif Al
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;